import React, { forwardRef } from "react";
import classNames from "classnames";

export type BasicTextInputProps =
  React.InputHTMLAttributes<HTMLInputElement> & {
    hasError?: boolean;
  };

const BasicTextInput = forwardRef<HTMLInputElement, BasicTextInputProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={classNames(
          "w-full rounded-md border px-4 py-3 text-sm transition-colors",

          // override global focus styles - otherwise the input gets a large blue shadow outline
          "!focus:outline-none !focus:ring-2 !focus:shadow-none !focus:[box-shadow:none]",

          !props.disabled && "bg-leafly-white text-gray-900",
          props.disabled && "bg-light-gray text-gray-500 cursor-not-allowed",

          className,
        )}
        {...props}
      />
    );
  },
);

BasicTextInput.displayName = "BasicTextInput";

export default BasicTextInput;
